/**
 * Created by Darius on 2017.04.02.
 */
const defaultState = {
    inProgress: true,
    saving: false,
    errors: null,
    openDeleteDialog: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'REQUEST_MEMBERS':
            return {
                ...state,
                inProgress: false,
                dataList: action.payload
            };
        case 'SEARCH_MEMBERS':
            return {
                ...state,
                searchText: action.payload
            };
        case 'REQUEST_MEMBER':
            return {
                ...state,
                inProgress: false,
                member: action.payload,
                initialValues: action.payload,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'SUBMIT_MEMBER':
            return {
                ...state,
                saving: false,
                member: action.payload,
                initialValues: action.payload,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'CONFIRM_DELETE_MEMBER':
            return {
                ...state,
                openDeleteDialog: action.payload
            };
        case 'DELETE_MEMBER':
            return {
                ...state,
                saving: false,
                openDeleteDialog: action.error ? true : false,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'MEMBERS_PAGE_UNLOADED':
        case 'MEMBER_PAGE_UNLOADED':
            return {...defaultState};
        case 'ASYNC_START':
            if (action.subtype === 'REQUEST_MEMBERS'
                || action.subtype === 'SEARCH_MEMBERS') {
                return { ...state, inProgress: true };
            } else if (action.subtype === 'SUBMIT_MEMBER'
                || action.subtype === 'DELETE_MEMBER'
                ) {
                return { ...state, saving: true };
            }
            break;
    }

    return state;
};